import * as THREE from 'three';

/** A stylized spray can. The cap shows the currently selected paint color. */
export interface SprayCanModel {
  group: THREE.Group;
  setColor(color: string): void;
  /** World position of the nozzle tip (for the particle cone). */
  nozzleWorldPos(target: THREE.Vector3): THREE.Vector3;
}

export function createSprayCan(scale = 1): SprayCanModel {
  const group = new THREE.Group();

  const bodyMat = new THREE.MeshStandardMaterial({
    color: 0xd8dde3,
    roughness: 0.35,
    metalness: 0.75,
  });
  const body = new THREE.Mesh(new THREE.CylinderGeometry(0.045, 0.045, 0.17, 20), bodyMat);
  body.position.y = 0.085;
  group.add(body);

  const label = new THREE.Mesh(
    new THREE.CylinderGeometry(0.0455, 0.0455, 0.085, 20),
    new THREE.MeshStandardMaterial({ color: 0x24344d, roughness: 0.6 }),
  );
  label.position.y = 0.085;
  group.add(label);

  const capMat = new THREE.MeshStandardMaterial({ color: 0xff5533, roughness: 0.5 });
  const cap = new THREE.Mesh(new THREE.CylinderGeometry(0.026, 0.03, 0.045, 16), capMat);
  cap.position.y = 0.192;
  group.add(cap);

  const nozzle = new THREE.Mesh(
    new THREE.CylinderGeometry(0.008, 0.008, 0.016, 10),
    new THREE.MeshStandardMaterial({ color: 0x222222, roughness: 0.8 }),
  );
  nozzle.position.y = 0.222;
  group.add(nozzle);

  group.scale.setScalar(scale);

  return {
    group,
    setColor(color: string) {
      capMat.color.set(color);
    },
    nozzleWorldPos(target: THREE.Vector3) {
      return nozzle.getWorldPosition(target);
    },
  };
}
